import React from "react";
import lazyWithRetry from "src/utils/lazy-with-retry";
import { PageTutorialProps } from "src/components/tutorial/PageTutorial";
import { createPortal } from "react-dom";
import { useProfileStore } from "src/store/profile";
import { useTutorialStore } from "src/store/tutorial";

const PageTutorialPortal: React.FC<PageTutorialProps> = (props) => {
  const { isShowTutorial } = useTutorialStore();

  const PageTutorialLazy = React.useMemo(() => {
    if (isShowTutorial) {
      return lazyWithRetry(() => import("src/components/tutorial/PageTutorial"));
    }

    return null;
  }, [isShowTutorial]);

  if (!PageTutorialLazy || !isShowTutorial) {
    return null;
  }

  return createPortal(
    <React.Suspense>
      <PageTutorialLazy {...props} />
    </React.Suspense>,
    document.getElementById("tutorial-portal-root") as HTMLElement,
  );
};

export default PageTutorialPortal;
